import Text14 from '@sdk/components/ui/typography/Text14';
import gettext, { pgettext } from '@sdk/lang/gettext';

import CloseIconSvg from '@web/assets/svg/Icons/32/close-gray.svg';

import { Container, CloseButton, Content, ActionText } from './chiliPiperBanner.styles';
import { useChiliPiper } from './useChiliPiper';

type Props = {
  path: string;
};

export const ChiliPiperBanner = ({ path }: Props) => {
  const { shouldShowChiliPiper, markAsSeen, bookDemo } = useChiliPiper(path);

  if (!shouldShowChiliPiper) return null;

  return (
    <Container>
      <Content>
        <Text14>📅</Text14>&nbsp;
        <ActionText underline onClick={bookDemo}>
          {gettext('Schedule a meeting')}
        </ActionText>
        &nbsp;
        <Text14>
          {pgettext('Schedule a meeting', 'with our expert for a full product tour!')}
        </Text14>
        &nbsp;
        <CloseButton onClick={markAsSeen}>
          <CloseIconSvg />
        </CloseButton>
      </Content>
    </Container>
  );
};
